export enum SpecificResourceMap {
  FitMedResources,
  Users,
  Patients,
  Tenant
}
